<template>
    <div>
        <b-card class="standardpage border-none">
            <b-card-header>
                <b-row>
                    <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
                        <i :class="users.icon" class="mr-1"></i>
                        <span>{{ users.title }}</span>
                    </b-col>
                </b-row>
            </b-card-header>

            <div v-show="!component" class="availtable datatable">
                <b-card class="w-100pct mb-2">
                    <b-card-body class="py-0">
                        <b-row v-if="!showfilter">

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Email" label-size="sm" class="">
                                    <b-input-group>
                                        <b-form-input v-model="email" :debounce="users.debounce"
                                            placeholder="Email"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!email"
                                                @click="email = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Role" label-size="sm">
                                    <treeselect instanceId="rolename" type="number" v-model="rolename" :clearable="true"
                                        :options="roles_options" :multiple="true" :show-count="true"
                                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                                        search-nested></treeselect>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="First Name" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="firstname" :debounce="users.debounce"
                                            placeholder="First Name"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!firstname"
                                                @click="firstname = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Last Name" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="lastname" :debounce="users.debounce"
                                            placeholder="Last Name"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!lastname"
                                                @click="lastname = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Agent (Initials)" label-size="sm" class="">
                                    <b-input-group>
                                        <b-form-input v-model="initials" :debounce="users.debounce"
                                            placeholder="Agent (Initials)"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!initials"
                                                @click="initials = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Department" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="department" :debounce="users.debounce"
                                            placeholder="Department"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!department"
                                                @click="department = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Status" label-for="status" label-cols="12" label-size="sm">
                                    <treeselect instanceId="status" type="number" v-model="status" :clearable="true"
                                        :options="status_options" :multiple="false"></treeselect>

                                </b-form-group>
                            </b-col>
                        </b-row>



                        <div v-if="password_reset" class="my-3 mx-n3 bg-lavenderblush">
                            <b-row class="divider my-3 mx-0">
                                <b-col></b-col>
                            </b-row>
                            <b-row class="mx-0">
                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label-cols="12" label="Email Reset" label-size="sm">
                                        <b-input-group>
                                            <b-form-input :value="password_user" :debounce="users.debounce" type="text"
                                                :disabled="true"></b-form-input>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary" :disabled="true">
                                                    <i class="fa fa-remove"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label="Email New Password" label-cols="12" label-size="sm">
                                        <b-input-group>
                                            <b-form-input id="zzzzx" v-model="password_text" :debounce="users.debounce"
                                                :type="password_show ? 'text' : 'password'" autocomplete="new-password" ></b-form-input>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary"
                                                    :disabled="!password_text" @click="password_show = !password_show">
                                                    <i class="fa fa-eye"></i>
                                                </b-button>
                                            </b-input-group-append>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary"
                                                    :disabled="!password_text" @click="users_resetpassword()">
                                                    <i class="fa fa-floppy-o text-primary"></i>
                                                </b-button>
                                            </b-input-group-append>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary"
                                                    :disabled="!password_text" @click="password_text = ''">
                                                    <i class="fa fa-remove"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row class="divider my-3 mx-0">
                                <b-col></b-col>
                            </b-row>
                        </div>



                    </b-card-body>
                </b-card>



                <div class="px-3">
                    <d-table classdivtable="availtable datatable" refid="users" :icon="users.icon" :busy="users.busy"
                        :toolbarlibrary="users.toolbarlibrary" :tools="users.tools" :badges="users.badges"
                        :fields="users.fields" :items="users.items" :downloaded="users.downloaded" :limit="users.limit"
                        :showpages="true" :offset="users.offset" :page="users.page" @load="users_load"
                        @click="users_click" @changed="users_click('save', $event)" @select="users_select">
                    </d-table>
                </div>
            </div>

            <div v-show="component">
                <component :is="component" :selection="users.selected" :config="cconfig"
                    @discard="users_click('discard')" @go="users_click('go')"></component>
            </div>
        </b-card>
    </div>
</template>


<script>
import gql from "graphql-tag";

import Setup_UserEdit from "./Components/Setup_UserEdit";

export default {
    name: "Setup_Users",
    components: { Setup_UserEdit },
    watch: {
        async firstname() {
            await this.users_load(0);
        },
        async lastname() {
            await this.users_load(0);
        },
        async department() {
            await this.users_load(0);
        },
        async email() {
            await this.users_load(0);
        },
        async initials() {
            await this.users_load(0);
        },
        async status() {
            await this.users_load(0);
        },
        async rolename() {
            await this.users_load(0);
        },
    },
    data() {
        return {
            firstname: null,
            lastname: null,
            initials: null,
            department: null,
            rolename: [],
            email: null,
            status: null,
            password_reset: false,
            password_user: null,
            password_show: false,
            password_text: null,
            roles_options: [],
            status_options: [
                {
                    id: "0",
                    label: "ENABLED",
                },
                {
                    id: "1",
                    label: "INVITED",
                },
                {
                    id: "2",
                    label: "SIGNUP",
                },
                {
                    id: "3",
                    label: "FORGOT",
                },
                {
                    id: "9",
                    label: "DISABLED",
                },
            ],
            users: {
                title: "Users",
                icon: "fa fa-user text-primary",
                debounce: 500,
                busy: false,
                page: 1,
                offset: 0,
                limit: 15,
                tools: "go,filter,download,clipboard,add,edit,deleteconfirm,password,invite",
                toolbarlibrary: [
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-user-secret text-black",
                        position: "toolbar",
                        action: "password",
                        label: "Password Reset",
                        component: {
                            name: "",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-paper-plane text-primary",
                        position: "toolbar",
                        action: "invite",
                        label: "Invite",
                        component: {
                            name: "",
                        },
                    },
                ],
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },

                    {
                        key: "email",
                        label: "Email",
                        sortable: true,
                        sortDirection: "desc",
                        type: "text",
                    },
                    {
                        key: "rolename",
                        label: "Role",
                        sortable: true,
                        sortDirection: "desc",
                        type: "text",
                        // class: "text-center",
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "firstname",
                        label: "First Name",
                        sortable: true,
                        sortDirection: "desc",
                        type: "text",
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "lastname",
                        label: "Last Name",
                        sortable: true,
                        sortDirection: "desc",
                        type: "text",
                        class: "d-none d-sm-table-cell",
                    },

                    {
                        key: "department",
                        label: "Department",
                        sortable: true,
                        sortDirection: "desc",
                        type: "text",
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "initials",
                        label: "Agent",
                        sortable: true,
                        sortDirection: "desc",
                        type: "text",
                        class: "text-center",
                        // class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "company",
                        label: "Company",
                        sortable: true,
                        sortDirection: "desc",
                        type: "text",
                        class: "d-none d-sm-table-cell",
                    },

                    {
                        key: "lastlogin",
                        label: "Last Login",
                        class: "d-none d-sm-table-cell",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .utc(true)
                                    .format("DD/MM/YYYY HH:mm:SS");
                            }
                            return result;
                        },
                    },
                    {
                        key: "status",
                        label: "Status",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center w-100px",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-right w-100px",
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-100px",
                    },
                ],
                badges: [
                    {
                        key: "status",
                        type: "badge",
                        Enabled: "success",
                        Invited: "warning",
                        Forgot: "info",
                        Signup: "secondary",
                        Disabled: "danger",
                        formatter: (value, key, item) => {
                            switch (parseInt(value)) {
                                case 0:
                                    return "Enabled";
                                    break;
                                case 1:
                                    return "Invited";
                                    break;
                                case 2:
                                    return "Forgot";
                                    break;
                                case 4:
                                    return "Signup";
                                    break;
                                case 9:
                                    return "Disabled";
                                    break;
                                default:
                                    return value;
                            }
                        },
                    },
                    {
                        key: "rolename",
                        type: "badge",
                        client: "warning",
                        user: "primary",
                        admin: "danger",
                        api: "info",
                        // formatter: (value, key, item) => {
                        //   if (value) {
                        //     return value.toLowerCase();
                        //   } else {
                        //     return "error";
                        //   }
                        // },
                    },
                ],
                items: [],
                selected: [],
                denied: [],
                downloaded: [],
            },
        };
    },
    async mounted() {
        this.accessdenied();
        await this.users_load();
    },

    methods: {
        accessdenied() {
            this.users.denied = [];
            if (!this.user.permissions.includes("setup_users.admin")) {
                this.users.denied.push("deleteconfirm");
            }
            if (!this.user.permissions.includes("setup_users.admin")) {
                this.users.denied.push("add");
                this.users.denied.push("save");
            }

        },

        async setup_usersroles() {

            const response = await this.$apollo.query({
                query: gql`
                    query {
                        setup_usersroles {
                            id: name
                                label: name
                        }
                        } 
                    `,
            })
            this.roles_options = response.data.setup_usersroles;

        },

        async users_load(offset, limit, page) {
            let state = this.users;

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.busy = true;

            let variables = {
                offset: state.offset,
                limit: state.limit,
                firstname: this.firstname,
                lastname: this.lastname,
                department: this.department,
                initials: this.initials,
                email: this.email,
                status: this.status ? this.status : null,
                rolename: this.rolename.length > 0 ? this.rolename.join(",") : null,
                dateformat: this.dateformat,
            };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query setup_users(
                            $limit: Int
                            $offset: Int
                            $email: String
                            $firstname: String
                            $lastname: String
                            $department: String
                            $initials: String
                            $status: String
                            $rolename: String
                            $dateformat: String
                        ) {
                            setup_users(
                            limit: $limit
                            offset: $offset
                            email: $email
                            firstname: $firstname
                            lastname: $lastname
                            department: $department
                            initials: $initials
                            status: $status
                            rolename: $rolename
                            dateformat: $dateformat
                                ) {
                                id
                                email
                                firstname
                                lastname
                                initials
                                department
                                company
                                rolename
                                lastlogin
                                status
                                rows
                                updated_at
                                updated_by
                                }
                            }
            `,
                    variables,
                });

                // USE LOCAL VARIABLE
                // if (limit == 0) {
                //     state.selected = response.data.setup_users
                // } else {
                //     state.items = []
                //     state.items = response.data.setup_users;
                // }

                if (limit == 0) {
                    state.downloaded = response.data.setup_users
                } else {
                    state.items = response.data.setup_users;
                }

                for (var k = 0; k < this.users.items.length; k++) {
                    if (this.users.items[k].value && this.users.items[k].spent) {
                        this.users.items[k].progress = (
                            (this.users.items[k].spent / this.users.items[k].value) *
                            100
                        ).toFixed(2);
                    }
                }


            } catch (error) {
                console.log(error);
            }

            await this.setup_usersroles();

            state.busy = false;
        },
        async users_click(a, ss) {
            let state = this.users;
            switch (a) {
                case "download_view":
                    state.downloaded = []
                    state.downloaded = this.state.items
                    break;

                case "download_all":
                    state.downloaded = []
                    await this.users_load(0, 0);
                    break;

                case "filter":
                    this.showfilter = !this.showfilter;
                    break;
                case "discard":
                    this.component = null;
                    await this.users_load();
                    break;
                case "go":
                    this.component = null;
                    await this.users_load();
                    break;
                case "add":
                case "edit":
                    this.component = "Setup_UserEdit";
                    break;

                case "save":
                    this.saveit(ss);
                    break;

                case "delete":
                    this.deleteit(ss);
                    break;

                case "password":
                    this.password_user = null
                    this.password_user = ss[0].email
                    this.password_reset = !this.password_reset
                    break;

                case "invite":
                    this.users_invite(ss);
                    break;
            }

        },
        async users_select(ss, tools) {

            this.password_reset = false
            
            let state = this.users;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "add", "download", "clipboard"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "password", "invite"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },
        async users_changed(ss) {
            console.log("users_changed", ss);
            await this.saveit(ss);
        },

        async users_invite(ss) {

            let state = this.users;

            if (await this.$bvModal.msgBoxConfirm('Selected users will be invited to the portal.', {
                title: 'Please confirm you want to invite?',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Yes',
                cancelTitle: 'No',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })) {
                let rows = [];
                ss.forEach(function (v) {
                    rows.push({ id: v.id });
                });

                let variables = {
                    rows,
                    action: 'change'
                };

                try {
                    const response = await this.$apollo.query({
                        query: gql`
                            query setup_users_email($rows: [setup_users_input], $action: String) {
                                setup_users_email(rows: $rows, action: $action) {
                                id
                            }
                        }
                        `,
                        variables,
                    });
                } catch (error) {
                    console.log(error);
                }

                state.busy = true
            } else {
                state.busy = false
            }
            await this.users_load();
        },
        async users_resetpassword(ss) {

            let state = this.users;
            state.busy = true

            let variables = {
                email: this.password_user,
                value: this.password_text
            };

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                            mutation setup_users_reset($email: String, $value: String) {
                                setup_users_reset(email: $email, value: $value) 
                        }
                        `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            state.busy = false

        },
        async saveit(ss) {
            this.busy = true;

            let variables = { rows: this.cleanit(ss) };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation setup_users_save(
                            $rows: [setup_users_input]
                        ) {
                            setup_users_save(rows: $rows) {
                                id
                                email
                                firstname
                                lastname
                                initials
                                department
                                company
                                rolename
                                lastlogin
                                status
                                ipaddress
                                iproaming     
                                rows
                                updated_at
                                updated_by
                            }
                        }
                        `,
                    variables,
                });
                console.log(response);
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },
        async deleteit(ss) {

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
            };

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
               mutation setup_users_delete(
                $rows: [setup_users_input]
              ) {
                setup_users_delete(rows: $rows) {
                  id
  
                }
              }
            `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            await this.users_load(0);
        },

    },
};
</script>

<style></style>